import { GridLegacy, Typography } from '@mui/material';
import MainCard from 'ui-component/cards/MainCard';
import { SxProps } from '@mui/system';
import { Theme } from '@mui/material/styles';
import { JSX } from 'react';

type CardSectionWithActionProps = {
  contents: JSX.Element;
  action: JSX.Element;
  title?: string;
  sx?: SxProps<Theme>;
  positionButtonOnTop?: boolean;
};

const CardSectionWithAction = ({
  contents,
  action,
  title,
  sx,
  positionButtonOnTop = false,
}: CardSectionWithActionProps) => (
  <GridLegacy container>
    <GridLegacy
      container
      item
      xs={12}
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      sx={sx}
    >
      <MainCard sx={{ width: 1 }}>
        {title && (
          <GridLegacy item container xs={12} justifyContent="space-between">
            <GridLegacy item xs="auto">
              <Typography variant="h4">{title}</Typography>
            </GridLegacy>
            <GridLegacy item xs="auto">
              {action}
            </GridLegacy>
          </GridLegacy>
        )}
        <GridLegacy
          item
          container
          xs={12}
          direction={positionButtonOnTop ? 'column-reverse' : 'row'}
        >
          <GridLegacy item xs={positionButtonOnTop ? 12 : 11}>
            {contents}
          </GridLegacy>
          {!title && (
            <GridLegacy item xs={positionButtonOnTop ? 12 : 1}>
              {action}
            </GridLegacy>
          )}
        </GridLegacy>
      </MainCard>
    </GridLegacy>
  </GridLegacy>
);

export default CardSectionWithAction;
